import { __assign, __read } from "tslib";
import querystring from 'querystring';
export function getPathName(projectID, showScreens, sectionID, screenID, hotspotID, commentID, isHandoff) {
    var url = "/prototype";
    if (projectID)
        url += "/" + projectID;
    if (showScreens) {
        url += '/screens';
        return url;
    }
    if (sectionID)
        url += "/section/" + sectionID;
    if (screenID)
        url += "/screen/" + screenID;
    if (hotspotID)
        url += "/layer/" + hotspotID;
    if (commentID)
        url += "/comment/" + commentID;
    if (isHandoff)
        url += "/handoff";
    return url;
}
// url can be a node url (https://nodejs.org/api/url.html#url_url_strings_and_url_objects)
// or window.Location (type https://developer.mozilla.org/en-US/docs/Web/API/Location) object
export function parse(url) {
    // prototype-viewer-import TODO:
    // After 4 years, do we still need to handle legacy URLs, or can we finally
    // drop the old format?
    // return isLegacy(url) ? parseLegacyURL(url) : parseURL(url);
    return parseURL(url);
}
// This is getting a little unwieldy and allows urls that aren't actually valid
// -- time to re-introduce a router or a neater way to parse this?
var urlRegexp = /^\/prototype\/(\w+)(\/screens)?(?:\/section\/(\d+))?(?:\/screen\/(\d+))?(?:\/layer\/(\d+)?)?(?:\/(?:comment\/?([-\w]+)?|(handoff)))?\/?$/;
function parseURL(url) {
    var pathname = url.pathname;
    pathname = pathname || '';
    var match = urlRegexp.exec(pathname);
    if (!match) {
        return {};
    }
    // eslint-disable-next-line prefer-const
    var _a = __read(match), projectID = _a[1], screens = _a[2], sectionID = _a[3], screenID = _a[4], hotspotID = _a[5], rest = _a.slice(6);
    screenID = screenID ? parseInt(screenID, 10) : undefined;
    sectionID = sectionID ? parseInt(sectionID, 10) : undefined;
    hotspotID = hotspotID ? parseInt(hotspotID, 10) : null;
    var _b = __read(rest, 2), highlightedComment = _b[0], handoff = _b[1];
    var inHandoff = !!handoff;
    var showScreens = !!screens;
    return __assign({ projectID: projectID,
        screenID: screenID,
        sectionID: sectionID,
        hotspotID: hotspotID,
        highlightedComment: highlightedComment,
        inHandoff: inHandoff,
        showScreens: showScreens }, parseQueryString(url));
}
// prototype-viewer-import TODO: see comment above
// const LEGACY_URL_PROJECT_SCREEN_REGEX = /^\/(\w+)(?:\?utm.*)?#(\d+)/;
// const LEGACY_URL_COMMENT_REGEX = /comments\/([-\w]+)/;
// function isLegacy(url) {
//   return LEGACY_URL_PROJECT_SCREEN_REGEX.test(url.pathname + url.hash);
// }
// function parseLegacyURL(url) {
//   const href = url.pathname + url.hash;
//   const match = LEGACY_URL_PROJECT_SCREEN_REGEX.exec(href);
//   if (!match) {
//     // eslint-disable-next-line no-console
//     console.warn(`${href} does not match legacy URL`);
//     return {};
//   }
//   // eslint-disable-next-line prefer-const
//   let [, projectID, screenID] = match;
//   if (screenID) {
//     screenID = parseInt(screenID, 10);
//   }
//   const [, highlightedComment] = LEGACY_URL_COMMENT_REGEX.exec(href) || [];
//   return {
//     projectID,
//     screenID,
//     highlightedComment,
//     inHandoff: false,
//     hotspotID: null,
//     ...parseQueryString(url),
//   };
// }
function parseQueryString(url) {
    var search = url.search;
    search = search || '';
    var qs = querystring.parse(search.slice(1));
    var frameless = qs.frameless;
    if (typeof frameless === 'undefined') {
        frameless = null;
    }
    else {
        frameless = qs.frameless === 'true';
    }
    return {
        isEmbedded: qs.emb === '1',
        isInTheExploreView: qs.exp === '1',
        hideOpenInMobile: qs.iosapp === 'true',
        isFrameless: frameless,
        frameOverride: qs.frameOverride,
    };
}
export function isEmbedded() {
    var qs = querystring.parse(window.location.search.slice(1));
    return !!qs.emb;
}
export function getFullPath() {
    return window.location.href.split(window.location.host)[1];
}
